import React, { Component } from 'react';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import moment from 'moment';
import _ from 'lodash';
import { Button, Layout, notification, Select, Steps } from 'antd/lib';
const Option = Select.Option;
import * as Icons from '@ant-design/icons';

import ProcesoImprimir from '../../procesos/ProcesoImprimir';

import getCasoViolenciaPorId from '../../../graphql/querys/violenciaGenero/getCasoViolenciaPorId.graphql';
import agregarMedida from '../../../graphql/mutations/violenciaGenero/agregarMedida.graphql';
import insertDocumento from '../../../graphql/mutations/common/insertDocumento.graphql';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};
@compose(
  graphql(insertDocumento, {
    name: 'insertDocumento',
  }),
  graphql(agregarMedida, {
    name: 'agregarMedida',
  })
)
class AgregarMedida extends Component {
  state = {
    estado: false,
    caso: {},
    step: 0,
    agresor: null,
  };

  componentDidMount() {
    if (this.props.match.params) {
      let _id = this.props.match.params.id;

      if (_id) {
        this.props.client
          .query({
            query: getCasoViolenciaPorId,
            variables: { _id: _id },
          })
          .then(res => {
            let caso = res.data.getCasoViolenciaPorId;

            let fechaVictima;
            // let fechaAgresor;

            if (caso.victima.fecha_nacimiento) {
              fechaVictima = moment(caso.victima.fecha_nacimiento).format(
                'DD/MM/YYYY'
              );
            }

            let datos = {
              ...caso,
              victima: {
                ...caso.victima,
                fecha_nacimiento: fechaVictima,
              },
            };

            this.setState({
              estado: true,
              caso: datos,
            });
          })
          .catch(err => {
            console.log(
              'Error en la obtencion de los datos completos del caso de violencia'
            );
            console.log(err);
          });
      }
    }
  }

  onCancel = () => {
    this.setState(
      {
        estado: false,
        caso: {},
      },
      () => {
        this.props.history.goBack();
      }
    );
  };

  generarDatos = () => {
    let datos = {};
    if (this.state.agresor) {
      let contra = this.state.agresor;
      let agresorEncontrado = _.find(this.state.caso.agresores, function(
        agresor
      ) {
        return contra === agresor._id;
      });

      datos = {
        ...this.state.caso,
        agresor: agresorEncontrado,
      };
    } else {
      // CASO DONDE NO HAY NINGUN CONTRAVENTOR AL GENERAR UNA ACTUACION.
      datos = {
        ...this.state.caso,
      };
    }
    return datos;
  };

  crearOpciones(agresor) {
    return (
      <Option key={agresor._id} value={agresor._id}>
        {agresor.nombre + ' ' + agresor.apellido}
      </Option>
    );
  }

  guardarDocumento = (htmlFinal, idModeloNota) => {
    let yo = this;
    // console.log('LLAALLALAALALAL: ');
    if (!this.state.guardado) {
      this.props
        .insertDocumento({
          variables: {
            documento: {
              tramite: 'caso_violencia',
              idTramite: this.state.caso._id,
              textoHtml: htmlFinal,
              idModeloNota,
            },
          },
        })
        .then(resDocumento => {
          let idDocumento = resDocumento.data.insertDocumento._id;

          this.props
            .agregarMedida({
              variables: {
                _id: this.state.caso._id,
                idDocumento,
              },
            })
            // eslint-disable-next-line no-unused-vars
            .then(resAgregarMedida => {
              notification.success({
                message: 'Documento agregado al caso',
                description:
                  'El documento se agrego correctamente al caso de violencia',
              });

              yo.setState(
                {
                  guardado: true,
                },
                () => {
                  // yo.props.history.goBack();
                  yo.props.history.push(
                    `/violenciaGenero/caso/${this.state.caso._id}`
                  );
                }
              );
            })
            .catch(err => {
              console.log('Error a la hora de agregar el documento al caso');
              console.log(err);
            });
        })
        .catch(err => {
          console.log('Ocurrio un error a la hora de insertar el documento...');
          console.log(err);
        });
    }
  };

  siguientePaso = () => {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  handleChange = valor => {
    // console.log('Contraventores elegidos: ', valor);
    this.setState({
      agresor: valor,
    });
  };

  render() {
    const { Step } = Steps;
    let { step } = this.state;
    if (!this.state.estado || this.state.loading) {
      return <Loading />;
    }

    let opciones = [];
    if (this.state.caso.agresores) {
      opciones = _.map(this.state.caso.agresores, this.crearOpciones);
    } else {
      return <Loading />;
    }

    return (
      <div>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Agregar Medida
          </h2>
          <br />
          <Steps size="small" className="stepsFormularios" current={step}>
            <Step title="Seleccionar Agresor" />
            <Step title="Generar Medida" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <div style={{ textAlign: 'center' }}>
                <h3>Seleccionar Agresor:</h3>
                <Select
                  style={{ width: '70%' }}
                  placeholder="Elegir Agresor"
                  onChange={this.handleChange}
                >
                  {opciones}
                </Select>
                <Button
                  type="primary"
                  style={{ float: 'rigth', marginTop: 5, marginLeft: 20 }}
                  onClick={() => this.siguientePaso()}
                >
                  Siguiente
                </Button>
              </div>
            )}
            {step === 1 && (
              <ProcesoImprimir
                datos={this.generarDatos()}
                onImprimir={(htmlActuacion, idModeloNota) =>
                  this.setState({ loading: true }, () =>
                    this.guardarDocumento(htmlActuacion, idModeloNota)
                  )
                }
                onGuardar={(htmlActuacion, idModeloNota) =>
                  this.setState({ loading: true }, () =>
                    this.guardarDocumento(htmlActuacion, idModeloNota)
                  )
                }
                onCancel={this.onCancel}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(AgregarMedida);
